// 403 surface (B5B §2.5: empty-state-with-rationale, never silently disable). PLAN-C4.0.
import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ForbiddenRoute() {
  return (
    <div className="flex flex-col items-center gap-4 py-20 text-center">
      <div className="flex size-12 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
        <Lock className="size-6" />
      </div>
      <h1 className="text-2xl font-semibold tracking-tight">Not permitted</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        Your roles don&apos;t grant access to this area. If you believe this is an error, contact a platform administrator.
      </p>
      <Button variant="outline" asChild>
        <Link to="/">← Back to dashboard</Link>
      </Button>
    </div>
  );
}
